export default "__VITE_ASSET__V4vylGjT__"